import { loadVue } from '@/scripts/vue/init'
import ShippingEstimator from '@/scripts/vue/components/product/ShippingEstimator.vue'

loadVue({})

console.log('Here at PDP')
